// src/components/admin/EditClientModal.tsx

import { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";
// import authApi from "services/authApi";
import http from "services/httpClient";

export interface EditClientModalProps {
  show: boolean;
  onClose: () => void;
  client: {
    id: number;
    name: string;
    industry: string;
  };
  onClientUpdated: (updatedClient: any) => void;
}

function EditClientModal({ show, onClose, client, onClientUpdated }: EditClientModalProps) {
  const [name, setName] = useState(client.name);
  const [industry, setIndustry] = useState(client.industry || "");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setName(client.name);
    setIndustry(client.industry || "");
  }, [client]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const { data } = await http.put(`/clients/${client.id}`, {
        name,
        industry: industry || null,
      });
      onClientUpdated(data);
      onClose();
    } catch (err: any) {
      // console.error("Edit client error:", err);
      setError(err.response?.data?.detail || "Failed to update client.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Client</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="editName">
            <Form.Label>Client Name</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="editIndustry">
            <Form.Label>Industry</Form.Label>
            <Form.Control
              type="text"
              value={industry}
              onChange={(e) => setIndustry(e.target.value)}
              placeholder="(Optional)"
            />
          </Form.Group>
          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={onClose} className="me-2" disabled={isSubmitting}>
              Cancel
            </Button>
            <Button type="submit" variant="primary" disabled={isSubmitting}>
              {isSubmitting ? <Spinner size="sm" animation="border" /> : "Save Changes"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default EditClientModal;
